export default Object.freeze({
  Own: 1,
  Inherited: 2,
  Default: 3,
});
